<template>
    <mt-loadmore :bottom-method="getSimDistributRecordHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
        <div class="vant-card">
            <div class="dataFrom">
                <van-cell-group>
                    <van-field v-model="dataFrom.iccidStart" label="开始iccid" placeholder="请输入开始iccid" />
                </van-cell-group>
                <van-cell-group>
                    <van-field v-model="dataFrom.iccidEnd" label="结束iccid" placeholder="请输入结束iccid" />
                </van-cell-group>
                <van-cell-group>
                    <van-field v-model="dataFrom.iccid" label="iccid虚拟号" placeholder="请输入iccid/虚拟号/接入号" />
                </van-cell-group>
                <van-cell-group>
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="pickerName"
                        label="选择代理商"
                        class="ksea"
                        placeholder="请选择代理商"
                        @click="showPicker = true"
                        />
                        <van-popup v-model="showPicker" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="columns"
                                @confirm="onConfirm"
                                @cancel="onCancel"
                            />
                        </van-popup>
                </van-cell-group>
            </div>
            <mt-button type="primary" size="large" @click="handleSearch">搜索</mt-button> 
            <mt-button type="primary" size="large" @click="distribution">分销</mt-button> 
            <mt-button type="primary" size="large" @click="agentLoginHandler">回收</mt-button> 
            <div class="content">
                <div class="vant-v" v-for="item in dataList" :key="item.id">
                    <van-row>
                        <van-col span="2"><img src="./../../assets/agent/user.png" alt=""></van-col>
                        <van-col span="18">代理商：{{item.agentPathNames}}</van-col>
                        <van-col span="4" v-if="item.cardState === 2 || item.cardState === 1">{{item.cardStateName}}</van-col>
                        <van-col span="4" style="color:#FE3B30" v-else>{{item.cardStateName}}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="2"></van-col>
                        <van-col span="17">ICCID：{{item.iccid}}</van-col>
                        <van-col span="5">{{item.isSoldName}}</van-col>
                    </van-row>
                </div>
            </div>
        </div>
    </mt-loadmore>
</template>
<script>
import { Toast,Dialog } from 'vant';
import { wxRequest} from '@/api/agent.js'
export default {
    name:'card',
    data(){
        return{
            dataFrom:{
                iccidStart:'',
                agentId:''
            },
            pageNo: 0,
            perPageNum: 5,
            allPage: 0,
            pickerName:'',
            dataList:[],
            columns: [],
            showPicker: false,
            allLoaded: false
        }
    },
    created(){
        this.getSelect()
        this.getSimDistributRecordHandler()
    },
    methods:{
        // 获取代理商数据
        getSelect(){
            wxRequest('/agent/list', {}, 'post').then(res => {
                if(res.data.code === '200'){
                    if(Array.isArray(res.data.data) && res.data.data.length>0){
                        res.data.data.forEach(item=>{
                            this.columns.push({id:item.id,text:item.name})
                        })
                    }
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        // 初始化数据
        getSimDistributRecordHandler(){
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                iccidStart:this.dataFrom.iccidStart,
                iccidEnd:this.dataFrom.iccidEnd,
		        iccid:this.dataFrom.iccid,
                perPageNum: this.perPageNum
            }
            wxRequest("sim/agent/listPage", data, "post").then(res => { 
                if(res.data.code == 200){
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }
                    this.dataList = this.dataList.concat(res.data.data.resultList)
                    this.$refs.loadmore.onBottomLoaded();    
                    this.$nextTick(function(){
                        window.scroll(0,0);
                    })                        
                }
            })
        },
        // 查询
        handleSearch() {
            this.pageNo = 0
            this.dataList = []
            this.getSimDistributRecordHandler()
        },
        // 分销
        distribution(){
            if(!this.dataFrom.iccidStart){
                Toast('请输入开始iccid')
                return
            }
            if(!this.dataFrom.iccidEnd){
                Toast('请输入结束iccid')
                return
            }
            if(!this.dataFrom.agentId){
                Toast('请选择代理商')
                return
            }
            Dialog.confirm({
                title: '提示',
                message: '确认进行分销？',
            }) .then(() => {
                var data ={
                    iccidStart:this.dataFrom.iccidStart,
                    iccidEnd:this.dataFrom.iccidEnd,
                    agentId:this.dataFrom.agentId,
                }
                wxRequest("sim/soldList", data, "post").then(res => { 
                    if(res.data.code == 200){      
                         this.$messagebox.alert(res.data.message)      
                         this.handleSearch()
                    }else{
                         this.$messagebox.alert(res.data.message)
                    }
                })
            }) .catch(() => {
                // on cancel
            });
        },
        // 回收
        agentLoginHandler(){
            if(!this.dataFrom.iccidStart){
                Toast('请输入开始iccid')
                return
            }
            if(!this.dataFrom.iccidEnd){
                Toast('请输入结束iccid')
                return
            }
            Dialog.confirm({
                title: '提示',
                message: '确认进行回收？',
            }) .then(() => {
                var data ={
                    iccidStart:this.dataFrom.iccidStart,
                    iccidEnd:this.dataFrom.iccidEnd
                }
                wxRequest("sim/recoverList", data, "post").then(res => { 
                    if(res.data.code == 200){      
                         this.$messagebox.alert(res.data.message)      
                         this.handleSearch()
                    }else{
                         this.$messagebox.alert(res.data.message)
                    }
                })
            }) .catch(() => {
                // on cancel
            });
        },
        onConfirm(value) {
            this.pickerName = value.text
            this.dataFrom.agentId = value.id
            this.showPicker = false;
        },
        onCancel() {
            this.showPicker = false;
        },
    }
}
</script>
<style lang="less" scoped>
    .van-cell:not(:last-child)::after{
        border:0
    }
    .vant-card{
        min-height: 100%;
        background: #F5F5F5;
        padding-top: 10px;
        .dataFrom{
            margin:0px 14px 16px 14px;
            padding:8px;
            padding-left:16px;
            padding-right:16px;
            border-radius: 8px;
            background: #fff;
            [class*=van-hairline]::after{
                border:0
            }
            .van-cell{
                border-bottom: 1px solid #F5F5F5;
                padding-bottom: 20px;
                padding-right: 0;
                padding-top: 16px;
            }
            .van-cell-group:last-child{
                 .van-cell{
                     border:0
                 }
            }
            .ksea{
                /deep/.van-cell__value{
                    .van-field__control{
                        background: url(./../../assets/agent/icon5.png) no-repeat right center;
                        background-size:13px 8px ;
                    }
                }
            }
            .van-cell-group{
                /deep/.van-cell__title{
                    color:#000;
                }
                /deep/.van-cell__value{
                    .van-field__control{
                        line-height: 24px;
                    }
                }
            }
        }
        button{
            margin: 16px 14px 0 14px;
            width: calc(100% - 28px);
            font-size:14px;
            background:#1677FE;
            border-radius:8px;
            height:48px;
        }
        .content{
            margin-top:32px;
            margin-left:14px;
            margin-right:14px;
            background:#fff;
            padding:16px;
            border-radius:8px;
            .vant-v{
                border-bottom: 1px solid #F5F5F5;
                margin-bottom:16px;
                .van-row{
                    padding-bottom:8px;
                    .van-col--2{
                        img{
                            width:15px;
                            height:16px;
                        }
                    }
                    .van-col--18{
                        color:#000;
                        font-size:14px;
                    }
                    .van-col--4{
                        color:#1677FE;
                        font-size:14px;
                        text-align:right;
                    }
                    .van-col--17{
                        color:#999;
                        padding-bottom:8px;
                        font-size:12px;
                    }
                    .van-col--5{
                        color:#1677FE;
                        font-size:14px;
                        text-align:right;
                    }
                }
            }
        }
    }
</style>